module.exports = __webpack_public_path__ + "static/media/AI入门banner.0ac24089.jpg";